import type { EventId } from '@atlassian/jira-forge-ui-types/src/common/types/analytics.tsx';
import { fireOperationalEvent } from '@atlassian/jira-forge-ui-analytics/src/common/utils/consumers/index.tsx';
import {
	FORGE_SAMPLING_RATE,
	OPERATIONAL_ACTIONS,
} from '@atlassian/jira-forge-ui-analytics/src/constants.tsx';

/** Given a promise, adds tracking events before the execution and after the execution (success and failure). */
export const trackPromiseExecution = (
	inputPromise: Promise<unknown>,
	eventId: EventId,
	enableSampling = true,
	getSamplingChance = (): number => Math.random() * 100, // injectable function to get a random sampling chance.
): Promise<unknown> => {
	// If sampling is enabled and the random chance exceeds the sampling rate, skip tracking.
	if (enableSampling && getSamplingChance() > FORGE_SAMPLING_RATE) {
		return inputPromise;
	}

	fireOperationalEvent(OPERATIONAL_ACTIONS.CALLED, { id: eventId });
	return inputPromise
		.then((response) => {
			fireOperationalEvent(OPERATIONAL_ACTIONS.SUCCEEDED, {
				id: eventId,
			});
			return response;
		})
		.catch((error) => {
			fireOperationalEvent(OPERATIONAL_ACTIONS.FAILED, {
				id: eventId,
			});
			throw error;
		});
};
